import { Navigate, useLocation } from 'react-router-dom';

import { BasicSpinner } from '../ui';

export interface GuardContext {
  loading: boolean;
  canAccessOnboarding: boolean;
  canAccessApp: boolean;
  needsSubscription: boolean;
}

interface AppGateProps {
  ctx: GuardContext;
  children: React.ReactNode;
}

export const AppGate: React.FC<AppGateProps> = ({ ctx, children }) => {
  const { loading, canAccessApp, canAccessOnboarding, needsSubscription } = ctx;
  const location = useLocation();
  const path = location.pathname;

  // 0 — loading gate
  if (loading) {
    return <BasicSpinner />;
  }

  // 1 — needs subscription and is trying to access the app
  if (path.startsWith('/app') && needsSubscription) {
    return <Navigate to="/edit/subscribe" />;
  }

  // 2 — trying to access app without onboarding
  if (path.startsWith('/app') && !canAccessApp) {
    return <Navigate to="/onboarding/introduction" />;
  }

  // 3 — trying to access onboarding when already onboarded
  if (path.startsWith('/onboarding') && !canAccessOnboarding) {
    return <Navigate to="/app" />;
  }

  // 4 — default: allow content
  return <>{children}</>;
};
